import { type EditorView } from 'prosemirror-view'
import { sum } from 'lodash'

import { BorderSelection } from 'common/Prose/utils/table/BorderSelection'
import { TableMap } from 'common/Prose/utils/table/TableMap'
import { determineDelimitingBorders } from './determineDelimitingBorders'

const determineTopOffset = (
  borders: ReturnType<typeof determineDelimitingBorders>,
  selection: BorderSelection,
  view: EditorView,
): number | undefined => {
  if (!borders.top) return

  let top
  const cellPos = selection.getAdjacentCellPosForSelectedBorder(borders.top.border, borders.top.type)

  if (cellPos[0][0]) {
    let node = view.domAtPos(cellPos[0][0] + 1).node as HTMLElement

    // NOTE: deal with merged cell, use the cell in the right position below
    if (borders.top.type === 'vertical' && cellPos[1][0] && (node as HTMLTableCellElement).rowSpan > 1) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      node = view.domAtPos(cellPos[1][0]! + 1).node as HTMLElement
    }
    top = borders.top.type === 'horizontal' ? node.offsetTop + node.offsetHeight : node.offsetTop
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  } else top = (view.domAtPos(cellPos[1][0]! + 1)!.node as HTMLElement).offsetTop

  return top
}

const determineLeftOffset = (
  borders: ReturnType<typeof determineDelimitingBorders>,
  columnWidths: number[],
): number | undefined => {
  if (!borders.left) return

  // TODO: Fix this the next time the file is edited.
  /* eslint-disable no-nested-ternary */
  return sum(
    columnWidths.slice(
      0,
      borders.left.type === 'horizontal'
        ? borders.left.border.fragmentIdx === undefined
          ? 0
          : borders.left.border.fragmentIdx
        : borders.left.border.rowOrColIdx,
    ),
  )
  /* eslint-enable no-nested-ternary */
}

const determineRightOffset = (
  borders: ReturnType<typeof determineDelimitingBorders>,
  columnWidths: number[],
): number | undefined => {
  if (!borders.right) return

  // TODO: Fix this the next time the file is edited.
  /* eslint-disable no-nested-ternary */
  return sum(
    columnWidths.slice(
      0,
      borders.right.type === 'horizontal'
        ? borders.right.border.fragmentIdx === undefined
          ? columnWidths.length
          : borders.right.border.fragmentIdx + 1
        : borders.right.type === 'vertical'
        ? borders.right.border.rowOrColIdx
        : borders.right.border.rowOrColIdx + 1,
    ),
  )
  /* eslint-enable no-nested-ternary */
}

export const determineDelimitingOffsets = (
  borders: ReturnType<typeof determineDelimitingBorders>,
  selection: BorderSelection,
  view: EditorView,
): { left: number | undefined; right: number | undefined; top: number | undefined } => {
  const tableMap = new TableMap({
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    node: view.state.selection.$anchor.nodeAfter!,
    posBeforeTable: view.state.selection.$anchor.pos,
  })
  const columnWidths = tableMap.getColumnWidths()

  const left = determineLeftOffset(borders, columnWidths)
  const right = determineRightOffset(borders, columnWidths)

  const top = determineTopOffset(borders, selection, view)

  return { left, right, top }
}
